import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings')({
  beforeLoad: ({ location }) => {
    // No settings index page anymore — send bare /settings to the first real page.
    if (location.pathname.replace(/\/$/, '') === '/settings') {
      throw redirect({ to: '/settings/agent-keys', replace: true })
    }
  },
  component: SettingsLayout,
})

function SettingsLayout() {
  return <Outlet />
}
